import React from 'react';
import { NOT_SET_TEXT } from '../../utils/timesheetDisplay';

/**
 * The small chooser a CONFLICT cell opens for a manager (owner-approved mock,
 * 2026-10-25): "Keep theirs <v>" / "Use the unit's <v>", and who set it. It
 * replaced the conflict LIST (no banner: *"the tab and highlighted values
 * show the issues"*). The write is the caller's — the existing
 * `POST /api/timesheets/conflicts/resolve` items request.
 *
 * "Set by" names the PERSON: only a person's own (`self`) value can conflict
 * (`server/helpers/timesheetRules.js#fieldState`). The payload carries no time
 * for the value, so none is shown (coordinator ruling, 2026-10-25).
 * Both options say what they keep in words — colour carries nothing alone.
 */
const OPTION =
  'flex w-full min-h-[44px] md:min-h-0 items-center justify-between gap-3 rounded-md px-2.5 py-1.5 text-left text-sm ' +
  'text-gray-800 hover:bg-gray-100 disabled:opacity-60 dark:text-gray-100 dark:hover:bg-gray-700 ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500';

export default function ConflictChooser({ personName, theirText, unitText, onPick, onEdit, busy, error, testId }) {
  const val = (t) => (t == null
    ? <span className="italic text-gray-500 dark:text-gray-400">{NOT_SET_TEXT}</span>
    : <span className="font-semibold tabular-nums">{t}</span>);
  return (
    <div role="dialog" aria-label="Settle this value" data-testid={testId}
      className="w-60 rounded-lg border border-gray-200 bg-white p-1 text-left shadow-xl dark:border-gray-700 dark:bg-gray-800">
      <button type="button" className={OPTION} disabled={busy} data-testid={testId && `${testId}-theirs`} onClick={() => onPick('theirs')}>
        <span>Keep theirs</span>{val(theirText)}
      </button>
      <button type="button" className={OPTION} disabled={busy} data-testid={testId && `${testId}-unit`} onClick={() => onPick('unit')}>
        <span>Use the unit&apos;s</span>{val(unitText)}
      </button>
      <div className="flex items-center justify-between gap-2 border-t border-gray-200 px-2.5 pb-1 pt-1.5 text-xs text-gray-600 dark:border-gray-700 dark:text-gray-400">
        <span className="min-w-0 truncate">Set by {personName}</span>
        {onEdit && (
          <button type="button" onClick={onEdit} className="shrink-0 min-h-[44px] md:min-h-0 font-medium text-blue-700 hover:underline dark:text-blue-300">
            Edit
          </button>
        )}
      </div>
      {error && <p role="alert" className="px-2.5 pb-1.5 text-xs text-red-700 dark:text-red-300">{error}</p>}
    </div>
  );
}
